import { useSelector } from 'react-redux';

/**
 * The signed-in admin's role, read from the token's `role` claim (see utils/session.js).
 * Superadmin-only (S) actions must be hidden when `isSuperAdmin` is false.
 */
export const useRole = () => {
    const role = useSelector((state) => state.auth.user?.role);
    return {
        role,
        isSuperAdmin: role === 'superadmin',
        isAdmin: role === 'admin' || role === 'superadmin',
    };
};
